<template>
  <div>
    <vue-headful title="Dashboard" />
    <Header page_title="Dashboard" />
    <div v-if="dashboard" class="sd-dashboard-container">
      <div class="sd-row notifications">
        <div class="inner-row container-fluid">
          <div class="sd-top-column">
            <div class="sd-title mini">
              <div class="title-text"><svg-icon icon="notification_bell" /> Meldingen<span class="notif-number">{{ announcementLength }}</span></div>
            </div>
          </div>
          <div class="announcement-overview">
            <AnnouncementContainer v-if="announcementLength > 0" />
            <div v-else class="empty-notification">Op het moment zijn er geen meldingen</div>
          </div>
        </div>
      </div>
      <div class="sd-row recommendations">
        <div class="sd-top-column container-fluid">
          <div class="sd-title mini">
            <div class="title-text"><svg-icon icon="heart" /> Matches <span class="notif-number">{{ (dashboard.matches_total > 100 ? '99+' : dashboard.matches_total) }}</span></div>
          </div>
            <template v-if="user.branch == 1">
                  <router-link :to="{ name: 'company-matches' }" class="text-warning">
                    <strong>Bekijk alle matches</strong>
                  </router-link>
            </template>
            <template v-else>
                <router-link :to="{ name: 'company-healthcare-matches' }" class="text-warning">
                    <strong>Bekijk alle matches</strong>
                </router-link>
            </template>
        </div>
        <div class="sd-job-overview">
          <template v-if="dashboard.matches && dashboard.matches.length">
              <template v-if="user.branch === 1">
                  <job-card-slide
                      v-for="job in dashboard.matches"
                      :key="job.job_id"
                      :job="job"
                      :all_jobs="dashboard.matches"
                      :recommended="true"
                  />
              </template>
              <template v-else>
                  <job-card-slide-healthcare
                      v-for="job in dashboard.matches"
                      :key="job.job_id"
                      :job="job"
                      :all_jobs="dashboard.matches"
                      :recommended="true"
                  />
              </template>
          </template>
          <template v-else>
            <div class="sd-job-item empty">
              <span>Er zijn geen matches gevonden</span>
            </div>
          </template>
          <div class="final-slide">
              <template v-if="user.branch == 1">
                  <router-link :to="{ name: 'company-matches' }" class="all-jobs">
                      <strong class="sd-title">
                <span class="title-text">
                  <svg-icon icon="suitcase" />Bekijk alle matches
                </span>
                      </strong>
                  </router-link>
              </template>
              <template v-else>
                  <router-link :to="{ name: 'company-healthcare-matches' }" class="all-jobs">
                      <strong class="sd-title">
                <span class="title-text">
                  <svg-icon icon="suitcase" />Bekijk alle matches
                </span>
                      </strong>
                  </router-link>
              </template>
          </div>
        </div>
      </div>
      <div class="sd-row applications">
        <div class="sd-top-column container-fluid">
          <div class="sd-title mini">
            <div class="title-text"><svg-icon icon="suitcase" /> Sollicitaties <span class="notif-number">{{ (dashboard.applicants_total > 100 ? '99+' : dashboard.applicants_total) }}</span></div>
          </div>
          <router-link :to="{ name: 'company-applicants' }" class="text-warning">
            <strong>Bekijk alle sollicitaties</strong>
          </router-link>
        </div>
        <div class="sd-job-overview">
          <template v-if="dashboard.applicants && dashboard.applicants.length ">
              <template v-if="user.branch === 1">
                  <job-card-slide
                      v-for="job in dashboard.applicants"
                      :key="job.job_id"
                      :job="job"
                      :all_jobs="dashboard.applicants"
                      :applicant="true"
                  />
              </template>
              <template v-else>
                  <job-card-slide-healthcare
                      v-for="job in dashboard.applicants"
                      :key="job.job_id"
                      :job="job"
                      :all_jobs="dashboard.applicants"
                      :applicant="true"
                  />
              </template>
          </template>
          <template v-else>
            <div class="sd-job-item empty">
              <span>Er zijn geen sollicitaties gevonden</span>
            </div>
          </template>
          <div class="final-slide">
            <router-link :to="{ name: 'company-applicants' }" class="all-jobs">
              <strong class="sd-title">
                <span class="title-text">
                  <svg-icon icon="suitcase" />Bekijk alle sollicitaties
                </span>
              </strong>
            </router-link>
          </div>
        </div>
      </div>
      <div class="sd-row confirmed" v-if="user.sub_branch !== '2' && user.branch !== 3">
        <div class="inner-row container-fluid">
          <div class="sd-top-column">
            <div class="sd-title mini">
              <div class="title-text"><svg-icon icon="checkmark_circle" /> Bevestigde opdrachten <span class="notif-number">{{ (dashboard.closed_total > 100 ? '99+' : dashboard.closed_total) }}</span></div>
            </div>
            <router-link :to="{ name: 'jobs-archived' }" class="text-warning">
              <strong>Bekijk archief</strong>
            </router-link>
          </div>
          <div class="sd-job-list">
            <template v-if="dashboard.closed.length">
              <job-card-slide
                v-for="job in dashboard.closed"
                :key="job.job_id"
                :job="job"
                :all_jobs="dashboard.closed"
                :closed="true"
                overview_type="list"
              />
            </template>
            <template v-else>
              <div class="sd-job-item empty">
                <span>Er zijn geen bevestigde opdrachten gevonden</span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="sd-row place-vacancy">
      <div class="container-fluid">
          <template v-if="user.branch === 1">
                <router-link
                  :to="{ name: 'job_step-1' }"
                  title="Plaats een vacature"
                  class="btn btn-warning btn-block"
                  v-ripple="'rgba(255, 255, 255, 0.35)'"
                >
                  Plaats vacature
                </router-link>
          </template>
          <template v-else>
              <router-link
                  :to="{ name: 'job_step-1-healthcare' }"
                  title="Plaats een vacature"
                  class="btn btn-warning btn-block"
                  v-ripple="'rgba(255, 255, 255, 0.35)'"
              >
                  Plaats vacature
              </router-link>
          </template>
      </div>
    </div>
    <div v-if="!privacy" id="privacy">
      <div class="content text-center">
        <div class="max-600">
          <p class="pt-1 mb-2">
            <i class="material-icons">error_outline</i>
            <strong>Privacy</strong>
          </p>
          <p class="text-14 mb-2">
            <strong class="d-block"
              >We nemen jouw privacy uiteraard heel serieus!</strong
            >We verstrekken bijvoorbeeld nooit gegevens aan derde. Maar we doen
            nog veel meer.
          </p>
          <p class="mb-2 text-14">
            <router-link
              :to="{ name: 'privacy' }"
              title="Lees meer"
              class="text-derect d-inline-block mr-2"
            >
              <strong>Lees meer ></strong>
            </router-link>
            <a
              title="Akkoord"
              class="text-derect d-inline-block ml-2"
              @click="okPrivacy"
            >
              <strong>Akkoord ></strong>
            </a>
          </p>
        </div>
      </div>
    </div>
    <div class="derect-availability">
      Derect is op werkdagen bereikbaar van 7:00 tot 17:00 op <a href="tel:+31850481976">085 048 1976</a> / <a href="mailto:info@derect.nl">info@derect.nl</a>
      <a
          v-if="isMobile()"
          href="https://wa.me/0850481976?text="
          v-ripple="'rgba(255, 255, 255, 0.35)'"
      >
        <img class="whatsapp-image" src="@/assets/whatsapp-square-brands.png" width="24" />
      </a>

      <a
          v-if="!isMobile()"
          href="https://web.whatsapp.com/send?phone=0850481976&text="
          v-ripple="'rgba(255, 255, 255, 0.35)'"
      >
        <img class="whatsapp-image" src="@/assets/whatsapp-square-brands.png" width="24" />
      </a>
    </div>
    <Footer />
  </div>
</template>

<script>
import JobCardSlide from "@/components/JobCardSlide.vue";
import JobCardSlideHealthcare from "@/components/JobCardSlideHealthcare.vue";

export default {
  data: function() {
    return {
      profile_status: null,
      applicants: null,
      jobs: null,
      job_ids: null,
      hired: null,
      user: null,
      announcementLength: '',
      notifs: null,
      dashboard: null,
      privacy: true
    };
  },
  async created() {
    this.refreshLocalUser();
    if (JSON.parse(localStorage.getItem("user-token"))) {
      await this.fetchData();
    }
  },
  props: ["matching_notification"],
  async mounted() {
  },
  watch: {
    $route: "fetchData",
    hired: {
      immediate: true,
      async handler() {
        // update the applicants
        // this.applicants = await this.getTokenAPIList("applicants"); // get notifications
        if (this.hired) {
          this.dashboard = await this.getTokenAPIList("company/dashboard"); // list of counts
        }
      }
    }
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      this.user = JSON.parse(localStorage.getItem("user"));
      // this.privacy = JSON.parse(localStorage.getItem("privacy"));
      this.notifs = await this.getTokenAPIList("notifications"); // get notifications
      await this.getTokenAPIList("notifications/seen"); // make the notifications seen
      this.dashboard = await this.getTokenAPIList("company/dashboard"); // list of counts
      localStorage.setItem("dashboard", JSON.stringify(this.dashboard));
      await this.notifications();
      this.$store.state.loading = false;

      jQuery('.sd-job-overview').each(function() {
        let $this = $(this),
          sideSpace = ($('#app').width() - $(this).parent().find('.container-fluid').width()) / 2,
          sidePadding = 0;

        if(jQuery(window).width() < 500)
          sidePadding = 0;

        $this.css('--scrollMargin', ((sideSpace+sidePadding) / 2) + 'px');
        $this.css('paddingLeft', (sideSpace+sidePadding)+'px');
        $this.css('paddingRight', (sideSpace+sidePadding)+'px');
      });

      jQuery(window).on('load resize', function() {
        jQuery('.sd-job-overview').each(function() {
          let $this = $(this),
            sideSpace = ($('#app').width() - $(this).parent().find('.container-fluid').width()) / 2,
            sidePadding = 0;

          if(jQuery(window).width() < 500)
            sidePadding = 0;

          $this.css('--scrollMargin', ((sideSpace+sidePadding) / 2) + 'px');
          $this.css('paddingLeft', (sideSpace+sidePadding)+'px');
          $this.css('paddingRight', (sideSpace+sidePadding)+'px');
        });
      });
    },
    async notifications() {
      const required = await this.checkProfileStatus();
      this.$store.state.announcement.announcements = [];
      var announcement;
      if (!required) {
        
        var requirements = [];
        var arr = this.$store.state.company_fields;
        for (var i = 0; i < arr.length; i++) {
          let key = arr[i];
          if (key == "contact_infix" || this.user[key]) {
            // it's not empty
          } else {
            requirements.push(key);
          }
        }
        var incomplete_url = { name: "company-step_1", params: {  } };
        var message = "Upload een foto van je school om het profiel compleet te maken.";
        var profile_fields = ["name","telephone","contact_salutation","contact_firstname","contact_lastname", "about"];
        $.each(profile_fields, function(i,v){
          if ($.inArray(v, requirements) !== -1)
          {
            incomplete_url = { name: "company-details", params: { action: "save" } };
            message = "Maak eerst je profiel compleet met informatie over de organisatie."
          }
        });

        announcement = {
          message: message,
          link: incomplete_url
        };
        this.$store.dispatch("announcement/add", announcement, {
          root: true
        });
      }

      if(this.matching_notification) {
        announcement = {
          message: "De vacature is aangemaakt. De matches worden gegenereerd. Binnen enkele minuten vind je jouw vacature met bijpassende matches terug.",
        };
        this.$store.dispatch("announcement/add", announcement, {
          root: true
        });
      }

      this.announcementLength = this.$store.state.announcement.announcements.length;
    },
    okPrivacy() {
      localStorage.setItem("privacy", JSON.stringify(true));
      this.privacy = true;
    },
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    }
  },
  components: {JobCardSlideHealthcare, JobCardSlide}
};
</script>
<style scoped>
.announcement-overview {
  background-color: #F6F6F6;
  padding: 20px;
  border-radius: 10px;
}

.sd-row .notif-number {
  background-color: #FFCD00;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 25px;
  height: 25px;
  border-radius: 100%;
  color: #FFF;
  font-weight: 400;
  font-size: 12px;
  line-height: 1;
  margin-left: 10px;
}

.sd-row.notifications .empty-notification {
  background-color: #FFF;
  border-radius: 10px;
  padding: 15px;
  color: #64513D;
  text-align: center;
}

.sd-top-column .text-warning {
  font-size: 14px;
  text-align: right;
}

.sd-row.matches .sd-top-column {
  margin-bottom: 10px;
}

.sd-row.matches .sd-job-overview {
  padding-top: 10px;
}

.sd-row .sd-job-overview {
  position: relative;
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: auto !important;
  scrollbar-color: #FFCD00 #FFF;
  scrollbar-width: thin;
}

/deep/.sd-row .sd-job-overview .sd-job-card {
  margin-bottom: 10px;
}

/* Hide scrollbar for Chrome, Safari and Opera */

.sd-row .sd-job-overview {
  --scrollMargin: 50px;
}

.sd-row .sd-job-overview::-webkit-scrollbar {
  height: 8px;
}

.sd-row .sd-job-overview::-webkit-scrollbar-track {
  background-color: #FFF;
  border-radius: 8px;
  outline: 2px solid #E1E1F533;
}

.sd-row .sd-job-overview::-webkit-scrollbar-button:start {
  background-color: transparent;
  width: var(--scrollMargin);
}

.sd-row .sd-job-overview::-webkit-scrollbar-button:end {
  background-color: transparent;
  width: var(--scrollMargin);
}

.sd-row .sd-job-overview::-webkit-scrollbar-thumb {
  background-color: #FFCD00;
  height: 8px;
  border-radius: 8px;
  cursor: pointer;
  width: 200px;
}

/deep/.sd-job-overview .sd-job-item {
  height: 100%;
  width: 230px;
}

/deep/.sd-job-overview .sd-job-item a {
  height: 100%;
}

.sd-job-overview .sd-job-item.empty,
.sd-job-list .sd-job-item.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 14px;
  border: 2px solid #F6F6F6;
  border-radius: 10px;
  background-color: #FFF;
  color: #64513D;
  padding: 15px;
  margin-right: 15px;
  min-width: 230px;
  height: unset;
}

/*/deep/.sd-job-overview .final-slide {
  margin-bottom: 10px;
}*/

/deep/.sd-job-overview .final-slide a {
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  background-color: #F6F6F6;
  border-radius: 10px;
  height: 100%;
  width: 230px;
  padding: 27px 15px;
  color: #64513D;
  font-size: 14px;
}

/deep/.sd-job-overview .final-slide a svg {
  color: #64513D;
}

.sd-job-list {
  margin-top: 20px;
  padding: 20px;
  background-color: #F6F6F6;
  border-radius: 10px;
}

/deep/.sd-job-list .sd-job-card:not(:last-child) {
  margin-bottom: 15px;
}

/deep/.sd-job-list .sd-job-item {
  width: 100%;
}

/deep/.sd-job-list .sd-job-item a {
  margin-right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/deep/.sd-job-list .sd-job-item a .job-item-button {
  display: block;
  border-radius: 10px;
  background-color: #FFCD00;
  padding: 5px 10px;
  margin-left: 15px;
}

.derect-availability {
  position: fixed;
  bottom: 0;
  max-width: 768px;
  width: 100%;
  background-color: #FFFFFF;
  text-align: center;
  padding: 10px 0 9px 0;
  border-top: 1px solid #ebebeb;
  font-size: 14px;
}

.derect-availability a {
  color: #625a55;
}

.derect-availability .whatsapp-image {
  margin-left: 10px;
  margin-top: -6px;
}

@media screen and (max-width: 500px) {
  /deep/.sd-job-list .sd-job-item .closed {
    flex-direction: column;
  }

  /deep/.sd-job-list .sd-job-item a .job-item-button {
    margin-top: 10px;
  }
}
</style>